
import Vue from 'vue';
// import FullpageModal from '../components/vue-fullpage-modal'

// import ProductDatasheetPopup from '../components/simpleshop/product-datasheet-popup.vue';
// Vue.component('ProductDatasheetPopup', ProductDatasheetPopup);

import BaseForm from '../base-components/BaseForm';
// var productlist =  require('./productlist.js');
// Vue.component('product-list', productlist.default);

import ProductList from './productlist.js';
Vue.component('product-list', ProductList);
// console.log(productlist);
